const ID_ALPHABET = "abcdefghijklmnopqrstuvwxyz0123456789";

/**
 * Creates a stable, collision-resistant node id (PRD §95).
 * Format: n_<24 chars> — URL-safe, matches the schema's node id pattern.
 */
export function newNodeId(): string {
  const bytes = new Uint8Array(24);
  if (typeof crypto !== "undefined" && "getRandomValues" in crypto) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  let out = "n_";
  for (const b of bytes) {
    out += ID_ALPHABET[b % ID_ALPHABET.length];
  }
  return out;
}

export function isNodeId(id: string): boolean {
  return /^[A-Za-z0-9_-]{4,64}$/.test(id);
}
